
import { Component, Vue, Watch } from "vue-property-decorator";
import { StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";
import RankingList2 from "@/views/components/RankingList/RankingList2.vue";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import { ScanforBubblePackageModule } from "@/store/modules/store_scanforbubblepackage";
import {
  ApiQueryType,
  ReceiveDataType,
  ErrorCode,
} from "@/common/glboalconstant";
import {
  checkCodesAndType,
  bubblePackage,
  abnormalMovingPartDataUpload,
  cloudPress,
} from "@/api/service";
import { LogHelper } from "@/common/LogHelper";
import dayjs from "dayjs";
import { DeviceItems2Module } from "@/store/modules/store_deviceitems2";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "scanforbubblepackage.",
  components: {
    DeviceItems2,
    Scan2,
    RankingList2,
    deviceStatus,
    StatisticalData,
    YtoTable,
    Form1,
    Form2,
    TableHeader,
    Scan,
  },
})
export default class extends Vue {
  private inputModel: inputDataModel_BubblePackage = {
    input_ScanCode: "",
    input_CarSignNum: "",
  };
  public globalConfig: any = {};
  public loginData: any = {};
  private timer;
  private uploading = false;
  // @Watch("inputModel", { deep: true })
  // onChildChanged(val: string) {
  //   this.asyncSendDataToNet(val);
  // }

  @Watch("form1error", { deep: true })
  onChildChanged(val: string) {
    this.errormessage = val;
  }
  mounted() {
    //初始化设备状态
    this.deviceItems = [];
    for (let index = 1; index <= 12; index++) {
      this.deviceItems.push({
        name: "设备" + index.toString(),
        title: index.toString(),
        status: "defult",
      });
    }
    try {
      //注册回调：从Dws获取数据，客户端需注册
      if (typeof obj_DWS_Core !== "undefined") {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            console.log("DWS传输过来的参数");
            console.log(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
    } catch (ex) {}

    //初始化统计数据栏目内显示的数据
    this.statisticalList = [
      { label: "总扫描数", value: "0", combine: "1" },
      { label: "累计体积重", value: "0", combine: "2" },
    ];

    try {
      //注册设备状态回调函数
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
      console.log("单记泡界面:注册回调函数完成");
    } catch (error) {
      console.log("单记泡界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);

    this.timer = setInterval(() => {
      if (this.DataQueue.length) {
        if (this.uploading) {
          return;
        } else {
          try {
            this.uploading = true;
            this.uploadData();
          } catch (error) {
            console.log("error");
            console.log(error);
          } finally {
            this.uploading = false;
          }
        }
      }
    }, 1000);
  }

  get form1error() {
    return ScanforBubblePackageModule.errorMessage;
  }
  set form1error(str){
    ScanforBubblePackageModule.setErrorMessage(str);
  }
  private uploadData() {
    if (this.DataQueue.length > 0) {
      let data = this.DataQueue.pop();
      debugger;
      if ("DEL" == data.OperationType) {
        bubblePackage(data.Content);
      } else if ("NEW" == data.OperationType) {
        let result = bubblePackage(data.Content);
        if (result != null && result.length > 0) {
          let pModel = data.Data;
          if (null == pModel) {
            return;
          }
          try {
            let j = JSON.parse(result);

            if (j != null && j.respcode == "000") {
              this.UploadOperationCountForBubblePackage(data.Content);
              debugger;
              pModel.Key = j.data.opRecord.id;
              pModel.state = "上传成功！";
              pModel.Info = j.respMessage;
            } else {
              if (j.respcode == "101") {
                this.UploadOperationCountForBubblePackage(data.Content);
              }
              pModel.state = "上传失败！";
              pModel.Info = j.respMessage;
            }
          } catch (ex) {
            pModel.state = "上传失败！";
            pModel.Info =
              result == null || result == undefined || result.length == 0
                ? ex.Message
                : result;
          }
        }
      }
    } else {
      return;
    }
  }
  private UploadOperationCountForBubblePackage(strJson) {
    try {
      let jobj = JSON.parse(strJson);
      debugger;
      obj_HttpRequest_Core.operationCountBLLEnqueueFacade({
        // ID = Guid.NewGuid().toString(),
        ID: obj_System_Core.getGuid(),
        request: {
          optTime: parseFloat(jobj.body?.opRecord?.createTime),
          compMac: this.globalConfig.LocalMac,
          compIP: this.globalConfig.LocalIPv4,
          devType: this.globalConfig.CurrentDeviceType.toString(),
          containerNo:
            strJson.indexOf("containerNo") != -1
              ? jobj.containerNo.toString()
              : "",
          waybillNo: jobj.body?.opRecord?.waybillNo,
          opCode: 179,
          userCode: jobj.body?.opRecord?.createUserCode,
          userName: jobj.body?.opRecord?.createUserName,
          orgCode: jobj.body?.opRecord?.orgCode,
          orgName: jobj.body?.opRecord?.orgCode,
          prevOrgCode: "",
          nextOrgCode: "",
          destOrgCode: "",
          sourceOrgCode: "",
          ioType: "01",
          expType: parseInt(jobj.body?.opRecord?.extend2),
          optArea: "",
          latticeNo: "",
          effectiveTypeCode: "",
          volume:
            jobj.body?.opRecord?.pkgLength +
            ";" +
            jobj.body?.opRecord?.pkgWidth +
            ";" +
            jobj.body?.opRecord?.pkgHeight,
          weighWeight: "",
          inputWeight: "",
          extend1: "",
          extend2: "",
          extend3: "",
        },
      });
    } catch (ex) {
      LogHelper.WriteLog(
        "单计泡：UploadOperationCountForBubblePackage失败" + ex.toString()
      );
    }
  }
  private countNum = 0;
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }

  private ReceiveDataEvent(args) {
    debugger;
    LogHelper.WriteLog(
      "ScanForBubblePackage_ReceiveData:" +
        " ReceiveDataType=" +
        args.ReceiveDataType.toString() +
        " JsonData=" +
        args.JsonData
    );
    switch (args.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        // RefreshCameraState?.Invoke(new JavaScriptSerializer().Deserialize<Camera_State>(args.JsonData.toString()));
        // break;
        this.SetCameraState(JSON.parse(args.JsonData.toString()));
        break;
      case ReceiveDataType.PackageData:
        LogHelper.WriteLog("收到底层数据:" + args.JsonData);
        this.setPackageData(JSON.parse(args.JsonData.toString()));
        break;
      case ReceiveDataType.ErrorState:
        // var vv = new JavaScriptSerializer().Deserialize<ErrorCode_Data>(args.JsonData.toString());
        // Warning = true;
        // WarningInfo = GetDescription((ErrorCode)int.Parse(vv.errorCode));
        LogHelper.WriteLog("收到底层错误状态码:" + args.JsonData);
        this.SetErrorCode(JSON.parse(args.JsonData.toString()));
        break;
        break;
      case ReceiveDataType.CodeCheck:
        // var vvv = new JavaScriptSerializer().Deserialize<CodeCheck_Data>(args.JsonData.toString());
        //SetCodeCheck();
        break;
      case ReceiveDataType.ErrorInfo:
        // var vvvv = new JavaScriptSerializer().Deserialize<ErrorInfo_Data>(args.JsonData.toString());
        //SetErrorInfo();
        break;
      default:
        break;
    }
  }

  private setPackageData(v) {
    debugger;
    // var v= new JavaScriptSerializer().Deserialize<Package_DataByQueueGetOn>(args.JsonData.toString());
    let model: any = {
      Id: v.code,
      SizeX: parseFloat(v.width),
      SizeY: parseFloat(v.length),
      SizeZ: parseFloat(v.height),
    };
    if (
      model.SizeX + model.SizeY + model.SizeZ > 90 ||
      model.SizeX > 40 ||
      model.SizeY > 40 ||
      model.SizeZ > 40
    ) {
      model.DimensionalWeight = parseFloat(
        ((model.SizeX * model.SizeY * model.SizeZ) / 10000).toFixed(2)
      );
    } else {
      model.DimensionalWeight = 0;
    }

    ScanforBubblePackageModule.setId(model.Id);
    ScanforBubblePackageModule.setSizeX(model == null ? 0 : model.SizeX);
    ScanforBubblePackageModule.setSizeY(model == null ? 0 : model.SizeY);
    ScanforBubblePackageModule.setSizeZ(model == null ? 0 : model.SizeZ);
    this.EditPackage.Info = model?.Info;
    ScanforBubblePackageModule.setDimensionalWeight(
      model == null ? 0 : model.DimensionalWeight
    );
    //PackageInfoInputVM.SetEditPackage(model);
    //PackageInfoInputVM.Save(true);
    //ScanFocuse?.Invoke();
    this.Save();
  }
  //DWS错误code处理函数
  public SetErrorCode(IntErrorCode) {
    switch (Number.parseInt(IntErrorCode.errorCode)) {
      case ErrorCode.NeedSuppleCode:
        this.form1error = "需要补码";
        break;
      case ErrorCode.TooMuchCode:
        this.form1error = "多条码";
        break;
      case ErrorCode.NoWeight:
        this.form1error = "无重量";
        break;
      case ErrorCode.OverWeight:
        this.form1error = "超重";
        break;
      case ErrorCode.NoVolumn:
        this.form1error = "无体积";
        break;
      case ErrorCode.TooLong:
        this.form1error = "体积超长";
        break;
      case ErrorCode.NoEntry:
        this.form1error = "超时，包裹不准入";
        break;
      case ErrorCode.ClearState:
        this.form1error = "";
        break;
      case ErrorCode.Reset:
        this.form1error = "";
        break;
      default:
        break;
    }

    //tbx_scanArea.Focus();
    //tbx_scanArea.SelectAll();
    return true;
  }
  //DWS设置相机状态
  private SetCameraState(strCameraState) {
    //更新设备状态
    debugger;
    let items = this.RefreshState(strCameraState);
    DeviceItems2Module.SetDeviceItemsState(items);

    return;
  }
  //DWS刷新设备状态信息
  private RefreshState(camera_State) {
    let result = [];
    for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
      let _info =
        "" +
        "设备" +
        i.toString() +
        "-" +
        "设备状态:" +
        camera_State.cameraState.camList[i - 1].camStatus +
        "-" +
        "设备模式:" +
        this.IsNullorEmptyorUndefined(
          camera_State.cameraState.camList[i - 1].camModel
        )
          ? ""
          : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

      result.push({
        title: _info,
        name: "设备" + i,
        status:
          camera_State.cameraState.camList[i - 1].camStatus == "1"
            ? "true"
            : "false",
      });
    }

    return result;
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  public ranklistdata: rankListModel = {
    avgEfficiency: "0",
    lastHourAvgEfficiency: "0",
    avgEfficiencyRank: "0",
    frequencyRank: "0",
    wholeTopEfficiency: "0",
  };

  public scanCodeChange() {
    ScanforBubblePackageModule.setId(this.ytoCode);
  }

  private currentRowChanged(element) {
    console.log("父组件接受子组件传来的数据currentrow");
    console.log(element);
    this.currentrow = element;
    this.callbackmodel = this.inputModel;
  }

  public deletedatahistory() {
    console.log("|FUNC|deletedatahistory");
    console.log(this.currentrow);
    if (this.currentrow === null) {
      this.$message.warning("请先选择要删除的行");
      return;
    }
    this.$confirm("是否确定要删除此数据？", "删除", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        console.log("执行删除以下数据的动作");
        try {
          if (this.delete(this.currentrow)) {
            this.currentrow = null;
          }
        } catch (error) {
          console.log("删除失败：" + error.message);
        }
      })
      .catch(() => {
        console.log("取消删除");
      });
  }

  private delete(currentRow) {
    try {
      debugger;
      if (currentRow.Id != null && currentRow.Id.length > 0) {
        var result = bubblePackage(
          this.GetAddParamsJsonStr("DELETE", currentRow)
        );
        if (result != null && result != "") {
          try {
            let j = JSON.parse(result);
            if (j != null && j.respcode == "000") {
              // Application.OpenForms[0]?.Invoke(new Action(() =>
              // {
              //     PackageList.Remove(SelectedPackage);
              // }));

              let dataHistoryOnForms = this.showList.filter(
                (obj) => obj.Index != currentRow.Index
              );
              this.showList = dataHistoryOnForms;
              if (this.Sum > 0) {
                this.Sum--;
                this.statisticalList[0].value = this.Sum;
              }
              if (!currentRow.IsPackage) {
                this.DimensionalWeightSum -= parseFloat(
                  currentRow.DimensionalWeight.toString()
                );
                this.statisticalList[1].value =
                  this.DimensionalWeightSum.toFixed(2);
              }
              this.form1error = "删除成功";
            } else {
              this.form1error = j.respMessage;
            }
          } catch (ex) {
            this.form1error = ex + "";
          }
        }
      } else {
        // Application.OpenForms[0]?.Invoke(new Action(() =>
        // {
        //     PackageList.Remove(SelectedPackage);
        // }));
        let dataHistoryOnForms = this.showList.filter(
          (obj) => obj.Index != currentRow.Index
        );
        this.showList = dataHistoryOnForms;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }
  public tableIndex = 1;

  public msg = "";
  private config = config;
  private statisticalList = [];
  public currentrow = null;
  public showList = [];
  public ytoCode = "";
  public EditPackage: any = {};
  public DimensionalWeightSum = 0;
  public Sum = 0;
  //扫描区扫码
  private ytocodeget() {
    try {
      this.Save();
    } catch (error) {
      console.log("ytocodeget");
      console.log(error);
    }
  }
  public isPackage = false;
  private codeCheckRet = "";
  public CodeCheck(code) {
    let rg = JSON.parse(checkCodesAndType(code.split()));
    this.isPackage =
      rg.ResultCode == "200" && rg.Type == ApiQueryType.strPackageCode;
    this.codeCheckRet = rg.Info;
    return (
      rg.ResultCode == "200" &&
      (rg.Type == ApiQueryType.strWayBillCode ||
        rg.Type == ApiQueryType.strPackageCode)
    );
  }
  public DataQueue = [];
  public Save() {
    this.form1error = "";
    debugger;
    let input_ScanCode = ScanforBubblePackageModule.id.trim();

    if (!this.CodeCheck(input_ScanCode)) {
      this.form1error = this.codeCheckRet;
      this.NewAbnormalMovingPartUpload(
        ScanforBubblePackageModule.id,
        this.codeCheckRet,
        null,
        "100"
      );
      return;
    }

    if (
      ScanforBubblePackageModule.sizeX == 0 ||
      ScanforBubblePackageModule.sizeY == 0 ||
      ScanforBubblePackageModule.sizeZ == 0
    ) {
      this.form1error = "长宽高不能为0";
      return;
    }
    //把要上传的数据加入到队列
    this.Sum++;
    this.DimensionalWeightSum += parseFloat(
      ScanforBubblePackageModule.dimensionalWeight.toString()
    );
    this.EditPackage.ScanTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.EditPackage.state = "正在上传！";
    this.EditPackage.IsPackage = this.isPackage;
    this.EditPackage.Id = ScanforBubblePackageModule.id;
    this.EditPackage.SizeX = ScanforBubblePackageModule.sizeX;
    this.EditPackage.SizeY = ScanforBubblePackageModule.sizeY;
    this.EditPackage.SizeZ = ScanforBubblePackageModule.sizeZ;
    this.EditPackage.DimensionalWeight =
      ScanforBubblePackageModule.dimensionalWeight;
    this.EditPackage.Index = this.tableIndex;
    this.tableIndex++;

    if (this.isPackage) {
      // // mVM.ScanFocuse?.Invoke();
      this.DimensionalWeightSum -= parseFloat(
        ScanforBubblePackageModule.dimensionalWeight.toString()
      );
      return;
    }
    this.statisticalList[0].value = this.Sum;
    this.statisticalList[1].value = this.DimensionalWeightSum.toFixed(2);

    let data = JSON.parse(JSON.stringify(this.EditPackage));
    this.DataQueue.unshift({
      Data: data,
      Content: this.GetAddParamsJsonStr("NEW", this.EditPackage),
      OperationType: "NEW",
    });
    // // Application.OpenForms[0]?.Invoke(new Action(() =>
    // // {
    // //     mVM.StatisticsVM.PackageList.Insert(0, data);
    // // }));
    this.showList.unshift(data);
    while (this.showList.length > 50) {
      this.showList.pop();
    }
    if (
      this.globalConfig.CurrentDeviceType == 4 &&
      ScanforBubblePackageModule.lockLengthWidthHeight
    ) {
      LogHelper.Console(
        "单计泡页面,设备类型为4(普通扫描)且选择了锁定长宽高,则不清空"
      );
    } else {
      ScanforBubblePackageModule.setSizeX(0);
      ScanforBubblePackageModule.setSizeY(0);
      ScanforBubblePackageModule.setSizeZ(0);
      ScanforBubblePackageModule.setDimensionalWeight(0);
    }
  }
  //新异常走件方法 add by klm 20220420
  private NewAbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null
  ) {
    debugger;
    try {
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

      let _request = {
        mty: "8606",
        signature: signsure, //登录时需要获取的签名
        createTime: datetimeNow,
        waybillNo: strCode,
        containerNo: null, //容器号,非必填
        deviceType: this.globalConfig.CurrentDeviceType.toString(), //设备类型，必填
        deviceNo: this.globalConfig.LocalIPv4, //大写,用冒号分隔，必填
        errorCode: exceptionCode, //异常码，必填
        errorMsg: strInfo, //异常信息，必填
        opCode: "179", //操作码，非必填
        ioType: null, //收发类型，非必填
        nextOrgCode: "", //下一网点，非必填
        weight: "", //重量，非必填
        createUserCode: this.loginData.userCode,
        extend1: "",
        extend2: "",
        extend3: "",
      };
      debugger;
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      console.log(stReturnStr);
      if (stReturnStr?.code == "000") {
        LogHelper.WriteLog("新异常走件方法上传成功");
      } else {
        LogHelper.WriteLog(
          "新异常走件上传失败,返回异常码：" +
            stReturnStr?.code +
            "异常信息：" +
            stReturnStr?.msg
        );
      }
    } catch (ex) {
      console.log(ex);
    }
  }
  //异常走件上传，废弃不用
  public AbnormalMovingPartUpload1(
    strCode,
    strInfo,
    strIoTypeName = null,
    strWeight = null,
    DaTouBi = null
  ) {
    try {
      var requestTongji = {
        devMac: this.globalConfig.LocalMac,
        devType: this.globalConfig.CurrentDeviceType.toString(),
        body: {
          containerNo: "",
          effectiveTypeCode: null,
          frequencyNo: null,
          empCode: this.loginData.userCode,
          ioType: "" /*dicIoType[cbx_recvType.Text]*/,
          nextOrgCode: "",
          opCode: "179",
          orgCode: this.loginData.orgCode,
          createTime: dayjs().valueOf(),
          previousOrgCode: "",
          waybillNo: strCode,
          weight: "",
          deviceType: strInfo,
          errorCode: DaTouBi,
          extend1: "",
          extend2: "",
          extend3: "",
        },
      };
      var response = JSON.parse(
        abnormalMovingPartDataUpload(JSON.stringify(requestTongji))
      );
      if (response.respcode != "000") {
        LogHelper.WriteLog("异常走件上传失败" + response.respMessage);
      } else {
        LogHelper.WriteLog("异常走件上传成功" + response.respMessage);
      }
    } catch (ex) {
      LogHelper.WriteLog("异常走件方法调用异常" + ex);
    }
  }
  public GetAddParamsJsonStr(operation, model, bIsDeviceData = false) {
    debugger;
    let job = {
      devMac: this.globalConfig.LocalMac,
      devType: this.globalConfig.CurrentDeviceType + "",
      body: {
        mac: this.globalConfig.LocalMac,
        aviType: 0,
        trace: 0,
        isFirstTransfer: 1,
        mty: "0140",
        opRecord: {
          auxOpCode: operation,
          createTime: dayjs().valueOf(),
          deviceType: this.globalConfig.CurrentDeviceType + "",
          ioType: "01",
          waybillNo: model.Id,
          opCode: 179,
          pkgWidth: model.SizeX + "",
          pkgLength: model.SizeY + "",
          pkgHeight: model.SizeZ + "",
          volumeWeight: model.IsPackage ? "0" : model.DimensionalWeight + "",
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          orgCode: this.loginData.orgCode,
          createOrgCode: this.loginData.orgCode,
          createTerminal: this.globalConfig.LocalIPv4,
          inOutFlag: this.globalConfig.InOutFlag,
          extend1: bIsDeviceData ? "1" : "0",
          extend2: model.IsPackage ? "20" : "10",
          extend3: "",
        },
      },
    };
    return JSON.stringify(job);
  }
  public callbackmodel = {};

  public selectElementContents(el) {
    console.log("|FUNC|selectElementContents");
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }

  private deviceItems: deviceItem[] = [];
  private errormessage = "";
}
